import { ProductId } from '@/features/pos/components/ProductCatalog/types'
import { FC, ReactNode, createContext, useCallback, useContext, useMemo, useState } from 'react'

interface ActionsContextValue {
    set: (id: string) => void
    unset: () => void
}

const Context = createContext<ProductId>(null)

const ActionsContext = createContext<ActionsContextValue>({
    set: () => {},
    unset: () => {},
})

interface ConfigurableProductIdProviderProps {
    children: ReactNode
}

const ConfigurableProductIdProvider: FC<ConfigurableProductIdProviderProps> = ({ children }) => {
    const [id, setId] = useState<ProductId>(null)

    const unset = useCallback(() => setId(null), [])

    const actions = useMemo(() => ({ set: setId, unset }), [unset])

    return (
        <Context.Provider value={id}>
            <ActionsContext.Provider value={actions}>{children}</ActionsContext.Provider>
        </Context.Provider>
    )
}

export default ConfigurableProductIdProvider

export const useConfigurableProductId = (): ProductId => useContext(Context)

export const useConfigurableProductIdActions = (): ActionsContextValue => useContext(ActionsContext)
